var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notificationActive)?_c('div',{staticClass:"bg-br-green-light p-4",style:(_vm.style)},[_c('div',{staticClass:"fluid-xs leading-tightest font-medium"},[_vm._v(_vm._s(_vm.notificationHeading))]),_vm._v(" "),_c('div',{staticClass:"fluid-xs leading-tightest font-light mt-2",domProps:{"innerHTML":_vm._s(_vm.notificationBody)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }